import { render, staticRenderFns } from "./roleSearch.vue?vue&type=template&id=1c3c6feb&scoped=true"
import script from "./roleSearch.vue?vue&type=script&lang=js"
export * from "./roleSearch.vue?vue&type=script&lang=js"
import style0 from "./roleSearch.vue?vue&type=style&index=0&id=1c3c6feb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3c6feb",
  null
  
)

export default component.exports